import React from "react";
import GET from "../../utils/GET";
import inFullscreen from "../../utils/inFullscreen";
import Tracker from "../Tracker";

let publisher = GET("publisher");
const userName = GET("name");
const uid = GET("uid");

if (!publisher) {
	publisher = "";
}

const TrackerWrapper = ({ data, test = false, children, ...props }) => (
	<Tracker
		details={{
			userId: data ? data.u : null,
			publisher,
			categories: data && data.c ? data.c : [],
			publisherName: data ? data.p || "" : null,
			sessionId: uid ? uid : data ? data.s || "" : null,
			userName: userName ? userName : "",
			postPurchase:
				data &&
				data.publisher_details &&
				data.publisher_details.post_purchase &&
				inFullscreen,
			survey:
				data && data.publisher_details && data.publisher_details.survey,
			upsell:
				data &&
				data.self_products &&
				data.self_products.products &&
				data.self_products.products.length > 0,
			url: window.location.href,
			customerType: (data && data.customer_type) || "",
			totalModules:
				data && data.display_order && Array.isArray(data.display_order)
					? data.display_order.length
					: -1,
		}}
		test={test}
		{...props}
	>
		{children}
	</Tracker>
);

export default TrackerWrapper;
